import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import CustomCard from "../../../components/card/CustomCard";
import { Loader } from "../../../components/loader/SpinnerLogo";
import useFetch from "../../../hooks/useFetch";
import useHandleErrors from "../../../hooks/useHandleErrors";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import { ClientService } from "../../../services/client/clientService";
import { Client } from "../../../type/entities/client-type";
import ClientForm from "../ClientForm";

export default function ClientEdit() {

    const { id = "" } = useParams<{ id: string }>();
    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new ClientService();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [data, loading] = useFetch(useCallback(async () => {
        const response = await service.getClientById(id as string);
        return response.getResponseData() as Client;
    }, [id]));

    const pageHeader = {
        title: `Perfil de ${data?.companyName}`,
        breadcrumb: [
            { name: 'Administración' },
            { name: 'Gestión de clientes' },
            { name: 'Clientes', href: menuRoutes.clients.path },
            { name: 'Editar Cliente' },
        ],
    };

    const handleSubmit = async (values: any) => {
        setIsLoading(true);
        try {
            const response = await (await service.editClient(values)).getResponseData();
            if (response.success) {
                navigate(-1);
                setTimeout(() => {
                    toast.success("Cliente editado correctamente");
                }, 100);
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error('Error al editar el cliente');
        } finally {
            setIsLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <CustomCard title="Datos Principales">
                {(data !== null && data !== undefined) && <ClientForm data={data} submit={handleSubmit} isLoading={isLoading} />}
            </CustomCard>
        </>
    );
}